import { nodeNameToFactoryId } from "../../compiler/utils/nodeNameToFactoryId";
import { PortExposures } from "../../parser/definition/types/PortExposures";
import { SourcePortAssignments } from "../types/SourcePortAssigments";

export function getPortAssignment(portExposures: PortExposures<any, any, any>): SourcePortAssignments {
    let portAssignment: SourcePortAssignments = {};

    for (let exposedPortName of Object.keys(portExposures)) {
        let portExposure = portExposures[exposedPortName];
        const childNodeId = nodeNameToFactoryId(portExposure.childName);
        portAssignment[exposedPortName] = [childNodeId, portExposure.portName];
    }


    return portAssignment;
}